import { useEffect } from "react";

const DEFAULT_BRAND_TITLE = "Tilley. How farms grow money";
const BRAND_SUFFIX = " - Tilley";

/**
 * Hook for setting page titles according to the required format:
 * - Home page: "Home - Tilley. How farms grow money"
 * - Other pages: "{title} - Tilley"
 * - Default: "Tilley. How farms grow money"
 *
 * @param {string} title - The page title
 */

export const usePageTitle = (title) => {
  useEffect(() => {
    let formattedTitle;
    if (!title) {
      formattedTitle = DEFAULT_BRAND_TITLE;
    } else if (title === "Home") {
      formattedTitle = `${title} - ${DEFAULT_BRAND_TITLE}`;
    } else {
      formattedTitle = `${title}${BRAND_SUFFIX}`;
    }

    document.title = formattedTitle;

    return () => {
      document.title = DEFAULT_BRAND_TITLE;
    };
  }, [title]);
};
